import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

export default function Privacy() {
  const { t } = useTranslation();
  return (
    <div className="flex-grow w-full max-w-4xl mx-auto p-4 sm:p-8 mt-8">
      <Helmet>
        <title>{t('meta_title_privacy')}</title>
        <meta name="description" content={t('meta_desc_privacy')} />
        
        {/* Social Media Meta */}
        <meta property="og:title" content={t('meta_title_privacy')} />
        <meta property="og:description" content={t('meta_desc_privacy')} />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={t('meta_title_privacy')} />
        <meta name="twitter:description" content={t('meta_desc_privacy')} />

        {/* Structured Data */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "WebPage",
              "name": "${t('meta_title_privacy')}",
              "description": "${t('meta_desc_privacy')}"
            }
          `}
        </script>
      </Helmet>
      <h1 className="text-3xl font-bold mb-6">{t('privacy_policy')}</h1>
      <div className="prose prose-invert max-w-none text-white/80 space-y-4" dangerouslySetInnerHTML={{ __html: t('privacy_content') }} />
    </div>
  );
}
